import { useAuth } from '../context/AuthContext';
import LoginPrompt from './LoginPrompt';
import Card from './ui/Card';

function RequireAdmin({ children }) {
    const { isAuthenticated, isAdmin } = useAuth();

    if (!isAuthenticated) {
        return <LoginPrompt />;
    }

    if (!isAdmin) {
        return (
            <Card className="p-8 max-w-md mx-auto mt-8 text-center">
                <h2 className="text-xl font-bold text-slate-100">Acesso negado</h2>
                <p className="text-slate-300 mt-2">
                    Esta área é restrita a administradores.
                </p>
            </Card>
        );
    }

    return children;
}

export default RequireAdmin;
